import Plyr from "plyr";

const selectors: Record<"block" | "open" | "dialog" | "player", string> = {
  block: "[data-video]",
  open: "[data-video-open]",
  dialog: "[data-video-dialog]",
  player: "[data-video-player]",
};

const init = () => {
  Array.from(document.querySelectorAll(selectors.block), (block) => {
    const openButton = block.querySelector(selectors.open) as HTMLElement;
    const dialog = block.querySelector(selectors.dialog) as HTMLDialogElement;
    const playerEl = block.querySelector(selectors.player) as HTMLElement;

    const player = new Plyr(playerEl, {});

    openButton.addEventListener("click", () => {
      if (!dialog.open) {
        dialog.showModal();
        player.play();
      }
    });

    dialog.addEventListener("close", () => player.pause());
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
